<script>

export default {
  props: {
    text: String,
    fontSize: String,
    textLength: Number,
    del: String,
    fontFace: String,
    animationCod: String,
    textRight: Boolean,
    marginLeft: Number,
    negativeMargin: {
      default: 0.25,
      type: Number
    }
  },
}
</script>

<template>
  <div :class="['wrap-word', 'word-animation-'+animationCod ]">
    <span :class="['word', 'text-center']">
    {{ text }}
  </span>
  </div>


</template>

<style scoped lang="scss">
$custom-letter-spacing: 0.05rem;

@font-face {
  font-family: 'Charlotte';
  src: url('@/assets/fonts/Charlotte.otf') format("opentype");
}

@font-face {
  font-family: 'Avenir';
  src: url('@/assets/fonts/Avenir Next.ttc');
}

@font-face {
  font-family: 'Trattatello';
  src: url('@/assets/fonts/Trattatello.ttf');
}

.wrap-word{
  width: inherit;
  color: white;
  font-family: v-bind(fontFace);
  font-size: v-bind(fontSize);
  position: relative;
  white-space: nowrap;
  margin-bottom: calc(v-bind(fontSize) * calc(v-bind(negativeMargin) ) * -1);
  margin-top: calc(v-bind(fontSize) * calc(v-bind(negativeMargin) ) * -1);
}

.word{
  animation: marginLeft calc(v-bind(textLength) * 0.5s) infinite linear;
}

.word-animation-1{
  overflow: hidden;
  //margin-bottom: calc(v-bind(fontSize) * -0.25);
  //margin-top: calc(v-bind(fontSize) * -0.25);
  animation: //aumentarOpacidadeLetra v-bind(del) infinite,
  aumentarEspacamentoLetra v-bind(del) infinite linear,
  delayEntrada v-bind(del) infinite;
}

.word-animation-2{
  //margin-bottom: calc(v-bind(fontSize) * -0.25);
  //margin-top: calc(v-bind(fontSize) * -0.25);
  //position: absolute;
  overflow: hidden;
  animation: typewriter calc(v-bind(del) / 2) steps(30) 0.5s infinite normal both,
  blinkTextCursor v-bind(del) steps(30) infinite normal;
}

.word-animation-3{
  overflow: hidden;
  //margin-bottom: calc(v-bind(fontSize) * calc(v-bind(negativeMargin) ) * -1);
  //margin-top: calc(v-bind(fontSize) * calc(v-bind(negativeMargin) ) * -1);
  animation: aumentarTamanhoLetra 5s infinite normal;
}


.word-animation-4{
  overflow: hidden;
  animation:// aumentarOpacidadeLetra 5s infinite,
  aumentarEspacamentoLetra v-bind(del) infinite ease-in-out,
  delayEntrada v-bind(del) infinite,
}

@keyframes delayEntrada {
  0% {
    display: block;
  }
  50% {
    display: none;
  }
  100% {
    display: block;
  }
}

@keyframes aumentarTamanhoLetra {
  0%{
    font-size: v-bind(fontSize);
  }
  50%{
    font-size: calc(v-bind(fontSize) * 0.95);
  }
  100%{
    font-size: v-bind(fontSize);
  }
}

@keyframes aumentarEspacamentoLetra {
  0% {
    letter-spacing: .1rem;
  }
  50% {
    letter-spacing: .15rem;
  }
  100% {
    letter-spacing: .1rem;
  }
}

@keyframes aumentarOpacidadeLetra {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
}

@keyframes marginLeft {
  0% {
    margin-left: 0;
  }
  100% {
    margin-left: calc(
        calc(max(
        v-bind(marginLeft)
        , -0.1) * -100vw
        ));
  }
}

@keyframes typewriter{
  from{width: 0;}
  to{width: 24em;}
}

@keyframes blinkTextCursor{
  from{border-right-color: rgba(255,255,255,.75);}
  to{border-right-color: transparent;}
}
</style>
